export const PAYMENT_RESET = "PAYMENT_RESET" as const;
export const PAYMENT_INVOICE_SET = "PAYMENT_INVOICE_SET" as const;
export const PAYMENT_RECEIPT_SET = "PAYMENT_RECEIPT_SET" as const;
